import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

// Create axios instance
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth API
export const authAPI = {
  login: (credentials) => api.post('/auth/login', credentials),
  verifyToken: () => api.get('/auth/verify'),
};

// Socios API
export const sociosAPI = {
  getAll: (params) => api.get('/socios', { params }),
  getById: (id) => api.get(`/socios/${id}`),
  getByTitulo: (titulo) => api.get(`/socios/titulo/${titulo}`),
  create: (data) => api.post('/socios', data),
  update: (id, data) => api.put(`/socios/${id}`, data),
  delete: (id) => api.delete(`/socios/${id}`),
};

// Receitas API
export const receitasAPI = {
  getAll: (params) => api.get('/receitas', { params }),
  getById: (id) => api.get(`/receitas/${id}`),
  getTotal: (params) => api.get('/receitas/total', { params }),
  create: (data) => api.post('/receitas', data),
  update: (id, data) => api.put(`/receitas/${id}`, data),
  delete: (id) => api.delete(`/receitas/${id}`),
};

// Despesas API
export const despesasAPI = {
  getAll: (params) => api.get('/despesas', { params }),
  getById: (id) => api.get(`/despesas/${id}`),
  getTotal: (params) => api.get('/despesas/total', { params }),
  create: (data) => api.post('/despesas', data),
  update: (id, data) => api.put(`/despesas/${id}`, data),
  delete: (id) => api.delete(`/despesas/${id}`),
};

// Balancete API
export const balanceteAPI = {
  getBalancete: (params) => api.get('/balancete', { params }),
};

// Eventos API
// export const eventosAPI = {
//   getAll: (params) => api.get('/eventos', { params }),
//   getById: (id) => api.get(`/eventos/${id}`),
//   create: (data) => api.post('/eventos', data),
//   update: (id, data) => api.put(`/eventos/${id}`, data),
//   delete: (id) => api.delete(`/eventos/${id}`),
// };

// Usuarios API
// export const usuariosAPI = {
//   getAll: () => api.get('/usuarios'),
//   getById: (id) => api.get(`/usuarios/${id}`),
//   create: (data) => api.post('/usuarios', data),
//   update: (id, data) => api.put(`/usuarios/${id}`, data),
//   delete: (id) => api.delete(`/usuarios/${id}`),
// };

// // Mensalidades API
// export const mensalidadesAPI = {
//   getAll: (params) => api.get('/mensalidades', { params }),
//   getById: (id) => api.get(`/mensalidades/${id}`),
//   getInadimplentes: () => api.get('/mensalidades/inadimplentes'),
//   getAdimplentes: () => api.get('/mensalidades/adimplentes'),
//   create: (data) => api.post('/mensalidades', data),
//   update: (id, data) => api.put(`/mensalidades/${id}`, data),
//   updateGlobalValue: (data) => api.put('/mensalidades/global-value', data),
//   delete: (id) => api.delete(`/mensalidades/${id}`),
// };

export default api;
